import { render, staticRenderFns } from "./stockStatusSummary2.vue?vue&type=template&id=f225bd00"
import script from "./stockStatusSummary2.vue?vue&type=script&lang=js"
export * from "./stockStatusSummary2.vue?vue&type=script&lang=js"
import style0 from "./stockStatusSummary2.vue?vue&type=style&index=0&id=f225bd00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports